/**
 *
 * @module commerceManagerExtrasMap
 *
 */

import Check from 'check-types';
import Logging from './../../logging/entry';
import RetryPolicy from './retryPolicy';

/**
 *
 * @class CommerceManagerExtrasMap
 * @desc Provides additional configuration information used by the manager.
 *
 */
export default class CommerceManagerExtrasMap {

    /**
     *
     * @param {RetryPolicy} retryPolicy
     * @param {Number} [checkOrderStatusDelay=4.0]
     * @param {SDK.Logging.Logger} [logger=Logging]
     *
     */
    constructor(retryPolicy, checkOrderStatusDelay = 4.0, logger = Logging) {

        const errorMessage = {
            ctor: 'CommerceManagerExtrasMap(getOrderStatusRetryPolicy, logger)',
            get retryPolicy() {
                return `${this.ctor} needs RetryPolicy instance`;
            },
            get checkOrderStatusDelay() {
                return `${this.ctor} checkOrderStatusDelay should be a Number`;
            }
        };


        if (Check.not.instanceStrict(retryPolicy, RetryPolicy)) {
            logger.warn('CommerceManagerExtrasMap', errorMessage.retryPolicy);
        }

        if (Check.not.number(checkOrderStatusDelay)) {
            logger.warn('CommerceManagerExtrasMap', errorMessage.checkOrderStatusDelay);
        }

        /**
         *
         * @access public
         * @type {RetryPolicy}
         * @desc Gets or sets the retry policy to help drive the retry behavior for service failures.
         *
         */
        this.retryPolicy = retryPolicy;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.checkOrderStatusDelay = checkOrderStatusDelay;

    }

}



// WEBPACK FOOTER //
// ./src/services/configuration/commerceManagerExtrasMap.js